/* ==========================================================================
   add_to_cart / begin_checkout dataLayer events.

   Fires on any product form submit and on the cart's checkout button, so GTM
   (and the Meta Pixel it injects) sees the same events the Base44 site sent.

   Note: Shopify's own checkout pages are sandboxed and do not run theme code,
   so the real Purchase event must come from Settings > Customer events or the
   Facebook & Instagram channel app. This file only covers the storefront.
   ========================================================================== */
(function () {
  'use strict';

  function push(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* never let analytics break a purchase */ }
  }

  function money(cents) { return Math.round(cents) / 100; }

  /* ------------------------------------------------ add_to_cart */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    var idField = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    if (!idField) return;

    // Ask Shopify for the authoritative price rather than scraping the DOM.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function () {
        var priceAttr = idField.getAttribute('data-price-cents');
        push({
          event: 'add_to_cart',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD',
          value: priceAttr ? money(priceAttr) * qty : undefined,
          items: [{ item_id: String(idField.value), quantity: qty }]
        });
      });
  }, true);

  /* ------------------------------------------------ begin_checkout */
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest('[name="checkout"], a[href="/checkout"]');
    if (!el) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        push({
          event: 'begin_checkout',
          currency: cart.currency || 'AUD',
          value: money(cart.total_price),
          items: (cart.items || []).map(function (i) {
            return {
              item_id: i.sku || i.handle,
              item_name: i.product_title,
              item_variant: i.variant_title,
              price: money(i.final_price),
              quantity: i.quantity
            };
          })
        });
      })
      .catch(function () {});
  }, true);
})();
